import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OpenProductGroupBannerEntityParams {
  product_type_id: string;
  id: number;
}
export class OpenProductGroupBannerEntity extends BaseEntityClass {
  product_type_id: string;
  limited_ordering_filter_id: number;

  constructor(params: OpenProductGroupBannerEntityParams) {
    super();
    this.type = "open_product_group_banner";
    this.entity_version = 1;
    this.product_type_id = params.product_type_id;
    this.limited_ordering_filter_id = params.id;
  }
}
